(function (window) {
  let darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  darkModeMediaQuery.addEventListener('change', handleDarkmode);
  handleDarkmode(darkModeMediaQuery);

  function handleDarkmode(e) {
    let darkModeOn = e.matches; // True if dark mode is enabled
    const favicon = document.querySelector('head link[rel=icon]');
    if (favicon) {
      let iconHref = favicon.getAttribute('href');

      // Modify favicon source if required
      if (darkModeOn) {
        favicon.setAttribute('href', iconHref.replace('favicon.png', 'favicon-dark.png'));
      } else {
        favicon.setAttribute('href', iconHref.replace('favicon-dark.png', 'favicon.png'));
      }
    }
  }
})(window);
